import { PaymentType } from '@afterpay/types'

export const isConsumerLendingOrder = (paymentType): paymentType is PaymentType.PCL => paymentType === PaymentType.PCL
